define(function(require, exports, module) {
    'use strict';
    var BaseView = require('common/base.view');
    var urlUtil = require('util/url.util');

    module.exports = BaseView.extend({
        initialize: function(options) {
            options.gameWindow
                ? this._openInExistingWindow(options.gameWindow, options.launchUrl)
                : this._openNewWindow(options.launchUrl);
        },

        /**
         * Open new window for game
         * @private
         * @param  {string} href
         * @return {Window}
         */
        _openNewWindow: function(href) {
            return this._handlePopupBlocker(urlUtil.openNewWindow(href));
        },

        /**
         * Open game in existing window
         * @private
         * @param  {Window} win
         * @param  {string} url
         * @return {Window}
         */
        _openInExistingWindow: function(win, url) {
            win.location.href = url;
            win.focus();

            return win;
        },

        /**
         * Handle Popup Blocker
         * @param {Window} win - Window instance
         * @private
         */
        _handlePopupBlocker: function(win) {
            if (!win) {
                this.showInfo({
                    content: this.translate('playtech.mobile.system.games.popup-blocker')
                });
            }

            return win;
        }

    });
});
